import { error } from '@utils/logger'
import { apiFetch } from '@utils/fetch'

export async function listTemplates(): Promise<string[]> {
  try {
    const resp = await apiFetch('/api/admin/templates')

    if (!resp.ok) return []
    const data = await resp.json()
    if (Array.isArray(data)) return data
    return []
  } catch (err) {
    error('failed to fetch templates', err)
    return []
  }
}

export default { listTemplates }
